(() => {
  const body = document.body;
  if (!body || !body.classList.contains('template-product')) return;

  const mobileQuery = window.matchMedia('(max-width: 767px)');
  let bar;
  let button;
  let titleNode;
  let priceNode;
  let statusNode;
  let visibilityObserver;
  let stateObserver;
  let observedMainButton;

  const selectors = {
    addButton: '.productView-form [data-btn-addtocart], .productView-form [data-btn-addToCart], #product-add-to-cart',
    title: '.productView-title span, .productView-title',
    price: '.productView-price .price-item--sale, .productView-price .price-item--regular, .productView-price .money, .productView-price'
  };

  const hasNativeSticky = () => Boolean(document.querySelector('[data-sticky-add-to-cart], .productView-stickyCart'));

  const getMainButton = () => {
    const buttons = Array.from(document.querySelectorAll(selectors.addButton));
    return buttons.find((candidate) => candidate.offsetParent !== null) || buttons[0] || null;
  };

  const getText = (selector, fallback) => {
    const node = document.querySelector(selector);
    const text = node?.textContent?.replace(/\s+/g, ' ').trim();
    return text || fallback;
  };

  const syncContent = () => {
    if (!button || !titleNode || !priceNode || !statusNode) return;

    const mainButton = getMainButton();
    const loading = Boolean(mainButton?.classList.contains('is-loading'));
    const disabled = !mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true' || loading;
    const mainLabel = mainButton?.textContent?.replace(/\s+/g, ' ').trim();

    titleNode.textContent = getText(selectors.title, 'Selected gear');
    priceNode.textContent = getText(selectors.price, '');
    statusNode.textContent = disabled && !loading ? 'Unavailable' : '';
    statusNode.hidden = !statusNode.textContent;
    button.disabled = disabled;
    button.classList.toggle('is-loading', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    button.textContent = mainLabel || (disabled ? 'Unavailable' : 'Add to cart');
  };

  const observeMainButtonState = () => {
    const mainButton = getMainButton();
    if (!mainButton || mainButton === observedMainButton || typeof MutationObserver === 'undefined') return;

    stateObserver?.disconnect();
    observedMainButton = mainButton;
    stateObserver = new MutationObserver(syncContent);
    stateObserver.observe(mainButton, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });
  };

  const createBar = () => {
    if (bar) return;
    if (hasNativeSticky()) return;

    bar = document.createElement('div');
    bar.className = 'olitans-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML = [
      '<div class="olitans-sticky-atc__copy">',
      '<span class="olitans-sticky-atc__title"></span>',
      '<span class="olitans-sticky-atc__meta">',
      '<span class="olitans-sticky-atc__price"></span>',
      '<span class="olitans-sticky-atc__status"></span>',
      '</span>',
      '</div>',
      '<button class="olitans-sticky-atc__button" type="button">Add to cart</button>'
    ].join('');

    document.body.appendChild(bar);
    button = bar.querySelector('.olitans-sticky-atc__button');
    titleNode = bar.querySelector('.olitans-sticky-atc__title');
    priceNode = bar.querySelector('.olitans-sticky-atc__price');
    statusNode = bar.querySelector('.olitans-sticky-atc__status');

    button.addEventListener('click', () => {
      const mainButton = getMainButton();
      if (!mainButton || mainButton.disabled || mainButton.classList.contains('is-loading')) return;
      mainButton.click();
      button.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(.97)' },
          { transform: 'scale(1)' }
        ],
        { duration: 180, easing: 'cubic-bezier(.2,.8,.2,1)' }
      );
    });

    body.classList.add('has-olitans-sticky-atc');
    observeMainButtonState();
    syncContent();
    window.requestAnimationFrame(() => bar?.classList.add('is-ready'));
  };

  const removeFallbackBar = () => {
    visibilityObserver?.disconnect();
    stateObserver?.disconnect();
    visibilityObserver = null;
    stateObserver = null;
    observedMainButton = null;
    bar?.remove();
    bar = null;
    button = null;
    titleNode = null;
    priceNode = null;
    statusNode = null;
    body.classList.remove('has-olitans-sticky-atc');
  };

  const setVisible = (visible) => {
    if (!bar) return;
    bar.classList.toggle('is-visible', visible && mobileQuery.matches);
  };

  const observeButton = () => {
    const mainButton = getMainButton();
    if (!mainButton || visibilityObserver) return;

    visibilityObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setVisible(entry.intersectionRatio < 1 && window.scrollY > 360);
    }, {
      root: null,
      threshold: [0, 1]
    });

    visibilityObserver.observe(mainButton);
  };

  const refresh = () => {
    if (hasNativeSticky()) {
      removeFallbackBar();
      return;
    }

    if (!mobileQuery.matches) {
      setVisible(false);
      return;
    }

    createBar();
    observeMainButtonState();
    syncContent();
    observeButton();
  };

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('change', (event) => {
    if (event.target.closest('.productView-details, .productView')) {
      window.setTimeout(refresh, 80);
    }
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.product-form__label, .productView-quantity, [data-product-attribute]')) {
      window.setTimeout(refresh, 120);
    }
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', refresh);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(refresh);
  }

  window.setTimeout(refresh, 500);
})();
